export const auditLogConstants = {
  GET_REQUEST: "GET_AUDITLOG_REQUEST",
  GET_SUCCESS: "GET_AUDITLOG_SUCCESS",
  GET_FAILURE: "GET_AUDITLOG_FAILURE",
  GET_BY_ID_REQUEST: "GET_AUDITLOG_BY_ID_REQUEST",
  GET_BY_ID_SUCCESS: "GET_AUDITLOG_BY_ID_SUCCESS",
  GET_BY_ID_FAILURE: "GET_AUDITLOG_BY_ID_FAILURE",
};

// Audit Log Action Types - for filter dropdown
export const auditLogActionTypes = [
  // Authentication & Access
  { value: "LoginSuccess", label: "Login Success", category: "Authentication" },
  { value: "LoginFailed", label: "Login Failed", category: "Authentication" },
  { value: "MfaSuccess", label: "MFA Success", category: "Authentication" },
  { value: "MfaFailed", label: "MFA Failed", category: "Authentication" },
  { value: "Logout", label: "Logout", category: "Authentication" },
  { value: "TokenRefresh", label: "Token Refresh", category: "Authentication" },
  { value: "ImpersonationStarted", label: "Impersonation Started", category: "Authentication" },
  { value: "ImpersonationEnded", label: "Impersonation Ended", category: "Authentication" },

  // User Management
  { value: "UserCreated", label: "User Created", category: "User Management" },
  { value: "UserUpdated", label: "User Updated", category: "User Management" },
  { value: "UserDeleted", label: "User Deleted", category: "User Management" },
  { value: "UserPasswordChanged", label: "User Password Changed", category: "User Management" },
  { value: "UserStatusChanged", label: "User Status Changed", category: "User Management" },

  // Runbook Operations
  { value: "RunbookCreated", label: "Runbook Created", category: "Runbook Operations" },
  { value: "RunbookUpdated", label: "Runbook Updated", category: "Runbook Operations" },
  { value: "RunbookDeleted", label: "Runbook Deleted", category: "Runbook Operations" },
  { value: "RunbookReactivated", label: "Runbook Reactivated", category: "Runbook Operations" },
  { value: "RunbookExecuted", label: "Runbook Executed", category: "Runbook Operations" },
  { value: "RunbookCancelled", label: "Runbook Cancelled", category: "Runbook Operations" },
  { value: "RunbookPublished", label: "Runbook Published", category: "Runbook Operations" },
  { value: "RunbookArchived", label: "Runbook Archived", category: "Runbook Operations" },
  { value: "RunbookAddedToGroup", label: "Runbook Added to Group", category: "Runbook Operations" },
  { value: "RunbookRemovedFromGroup", label: "Runbook Removed from Group", category: "Runbook Operations" },

  // Runbook Version Operations
  { value: "RunbookVersionCreated", label: "Runbook Version Created", category: "Runbook Version Operations" },
  { value: "RunbookVersionUpdated", label: "Runbook Version Updated", category: "Runbook Version Operations" },
  { value: "RunbookVersionDeleted", label: "Runbook Version Deleted", category: "Runbook Version Operations" },
  { value: "RunbookVersionActivated", label: "Runbook Version Activated", category: "Runbook Version Operations" },
  { value: "RunbookVersionDeactivated", label: "Runbook Version Deactivated", category: "Runbook Version Operations" },

  // Variable Operations
  { value: "VariableCreated", label: "Variable Created", category: "Variable Operations" },
  { value: "VariableUpdated", label: "Variable Updated", category: "Variable Operations" },
  { value: "VariableDeleted", label: "Variable Deleted", category: "Variable Operations" },
  { value: "VariableLineCreated", label: "Variable Line Created", category: "Variable Operations" },
  { value: "VariableLineUpdated", label: "Variable Line Updated", category: "Variable Operations" },
  { value: "VariableLineDeleted", label: "Variable Line Deleted", category: "Variable Operations" },

  // Permission & Access Control
  { value: "PermissionGroupCreated", label: "Permission Group Created", category: "Permission & Access Control" },
  { value: "PermissionGroupUpdated", label: "Permission Group Updated", category: "Permission & Access Control" },
  { value: "PermissionGroupDeleted", label: "Permission Group Deleted", category: "Permission & Access Control" },
  { value: "UserAddedToGroup", label: "User Added to Group", category: "Permission & Access Control" },
  { value: "UserRemovedFromGroup", label: "User Removed from Group", category: "Permission & Access Control" },
  { value: "PermissionAssigned", label: "Permission Assigned", category: "Permission & Access Control" },
  { value: "PermissionRevoked", label: "Permission Revoked", category: "Permission & Access Control" },

  // Connector Operations
  { value: "ConnectorCreated", label: "Connector Created", category: "Connector Operations" },
  { value: "ConnectorUpdated", label: "Connector Updated", category: "Connector Operations" },
  { value: "ConnectorDeleted", label: "Connector Deleted", category: "Connector Operations" },
  { value: "ConnectorSecretCreated", label: "Connector Secret Created", category: "Connector Operations" },
  { value: "ConnectorSecretUpdated", label: "Connector Secret Updated", category: "Connector Operations" },
  { value: "ConnectorSecretRetrieved", label: "Connector Secret Retrieved", category: "Connector Operations" },
  { value: "ConnectorAuthTested", label: "Connector Auth Tested", category: "Connector Operations" },

  // Scheduler Operations
  { value: "SchedulerCreated", label: "Scheduler Created", category: "Scheduler Operations" },
  { value: "SchedulerUpdated", label: "Scheduler Updated", category: "Scheduler Operations" },
  { value: "SchedulerDeleted", label: "Scheduler Deleted", category: "Scheduler Operations" },

  // System & Data
  { value: "SystemSettingChanged", label: "System Setting Changed", category: "System & Data" },
  { value: "IntegrationConfigured", label: "Integration Configured", category: "System & Data" },
  { value: "DataExported", label: "Data Exported", category: "System & Data" },
  { value: "DataImported", label: "Data Imported", category: "System & Data" },

  // Security Events
  { value: "UnauthorizedAccessAttempt", label: "Unauthorized Access Attempt", category: "Security Events" },
  { value: "SuspiciousActivity", label: "Suspicious Activity", category: "Security Events" },
];

// Authentication methods for filter
export const authenticationMethods = [
  { value: "CloudSync", label: "CloudSync" },
  { value: "Okta", label: "Okta" },
  { value: "AzureAD", label: "Azure AD" },
];

// Resource types for filter
export const resourceTypes = [
  { value: "Runbook", label: "Runbook" },
  { value: "RunbookVersion", label: "Runbook Version" },
  { value: "User", label: "User" },
  { value: "ConnectorSecret", label: "Connector Secret" },
  { value: "Connector", label: "Connector" },
  { value: "PermissionGroup", label: "Permission Group" },
  { value: "Permission", label: "Permission" },
  { value: "Scheduler", label: "Scheduler" },
  { value: "Variable", label: "Variable" },
  { value: "VariableLine", label: "Variable Line" },
  { value: "SystemSetting", label: "System Setting" },
];

// Helper function to get action type label.
// The API serializes ActionType as the enum NAME (a string), e.g.
// "RunbookExecuted" — see the API's AuditLog model
// ([JsonConverter(typeof(JsonStringEnumConverter))]). We look that string up
// in auditLogActionTypes for a friendly label. This is drift-proof: unlike the
// old positional numeric map, it can't be knocked out of sync when the backend
// enum gains or reorders members (root cause of #1898/#1899).
export const getActionTypeLabel = (actionType) => {
  if (typeof actionType !== 'string' || actionType.length === 0) {
    return "Unknown Action";
  }

  const found = auditLogActionTypes.find(
    (type) => type.value.toLowerCase() === actionType.toLowerCase()
  );
  // Fall back to the raw enum name if we don't have a friendly label yet
  // (e.g. a brand-new action type the frontend list hasn't caught up on).
  return found ? found.label : actionType;
};
